module.exports = "../study/imgs/maps/Nagano/S8/Agriculture/RiceQ/Nagano_RiceQ_HadGEM2_RCP45_End.png";